
import AppWrapper from './AppWrapper.svelte';

var app = new AppWrapper({
	target: document.body
});

export default app;